/**
 * Format error message from API response
 * Handles string, object, and array error formats
 */
export const formatErrorMessage = (error, defaultMessage = 'Bir hata oluştu') => {
  if (!error?.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // If detail is a string
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array (FastAPI validation errors)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      if (typeof err === 'object') {
        // FastAPI validation error format: {type, loc, msg, input, url}
        return err.msg || err.message || 'Doğrulama hatası';
      }
      return String(err);
    }).join(', ');
  }

  // If detail is an object
  if (typeof detail === 'object') {
    return detail.message || detail.msg || detail.error || defaultMessage;
  }

  return defaultMessage;
};
